var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 153,
    viewBox: "0 0 153 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_847_2581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1792 60.9692C68.266 60.3419 67.3435 59.7204 66.537 59.2414C52.1957 50.6231 34.4204 45.2464 17.7023 46.0821C17.096 46.1173 16.6083 46.6088 16.6394 47.2206C16.6704 47.8324 17.1746 48.2767 17.7817 48.2411C34.126 47.5162 51.4257 52.7471 65.4073 61.1534C65.8613 61.4161 66.3694 61.7526 66.8806 62.0872C65.7571 62.8409 65.0215 63.7901 64.5635 64.7893C63.9125 66.3197 63.9034 68.109 64.3786 69.9338C65.0521 72.4838 66.6179 75.043 68.5292 77.0883C70.0138 78.6452 71.7192 79.8649 73.2366 80.3533C74.4836 80.7879 75.6284 80.7565 76.5933 80.3044C77.6069 79.8241 78.4553 78.8101 78.8536 77.0058C79.5917 73.9557 78.6027 70.9575 76.6834 68.1821C75.2799 66.1585 73.392 64.3101 71.4452 62.7052C72.2207 62.5723 73.093 62.4888 74.0649 62.4524C81.4774 62.3711 91.1111 66.8845 100.616 73.2573C115.067 82.9666 129.199 97.0591 134.607 106.322C134.882 106.793 135.586 107.016 136.115 106.711C136.644 106.406 136.798 105.686 136.523 105.215C130.978 95.7167 116.609 81.3424 101.837 71.3982C91.9042 64.7477 81.7552 60.1109 74.0391 60.2626C72.1126 60.3253 70.4814 60.5323 69.1792 60.9692ZM68.8465 63.4706C67.7234 64.0141 66.9913 64.7514 66.5776 65.62C66.1107 66.7293 66.1757 68.0562 66.4994 69.3387C67.0707 71.5279 68.4652 73.767 70.1223 75.5392C71.2812 76.7593 72.5969 77.7836 73.8029 78.2419C74.4747 78.4837 75.0905 78.5487 75.6366 78.3383C76.1475 78.0434 76.485 77.4281 76.7367 76.548C77.2843 74.0277 76.3723 71.6156 74.8638 69.4428C73.302 67.1957 70.9977 65.0625 68.8465 63.4706Z",
    fill: "#FF6456"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8606 48.1668C24.1679 47.1493 30.463 44.0402 35.525 40.173C36.0046 39.7912 36.1051 39.1036 35.7663 38.6695C35.3828 38.1562 34.6759 38.0389 34.1971 38.4203C29.3912 42.0346 23.4747 45.0307 17.4979 45.9624C16.9127 46.0904 16.4949 46.6466 16.5787 47.228C16.7087 47.8877 17.2754 48.2948 17.8606 48.1668Z",
    fill: "#FF6456"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5707 48.2976C23.6089 49.3246 28.5965 54.1076 32.1914 58.8544C32.5302 59.2885 33.2376 59.4049 33.7172 59.023C34.1961 58.6416 34.2955 57.954 33.9113 57.4412C30.0309 52.3344 24.5136 47.2285 17.9228 46.1007C17.3317 46.0221 16.7734 46.4496 16.6653 47.0368C16.5565 47.6245 16.9803 48.2186 17.5707 48.2976Z",
    fill: "#FF6456"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_847_2581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white",
    transform: "translate(96.9949) rotate(60)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.317dd9501e705db83925a8a6bedecb96.svg";
export { ForwardRef as ReactComponent };